import React ,{}from "react";
import { useTranslation } from 'react-i18next';
import "./index.scss";
const Layout = ({children, className='', theme=''})=>{
    if(theme === 'Wcip') {
        return <>{children}</>;
    }
    return <div className={`ThreeInOneLayout ${className}`}>{children}</div>
}
const ButtonLayout = ({children, className='', style={}})=>{
    return <div  style={style} className={`ThreeInOneButtonLayout ${className}`}>{children}</div>
}


const Wapper = ({children, className='', title =''})=> {
    const { t } = useTranslation();
    if (title) {
        document.title = t(title);
    }
    return <div className={`ThreeInOneWapper ${className}`}>{children}</div>
}

export {Layout,Wapper,ButtonLayout};